import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

interface Props {
    type: 'receive' | 'send'
}

function SkeletonCrypto({ type }: Props) {
    if (type === 'send') {
        return (
            <>
                <div className={styles.addressInput}>
                    <Loader width="100%" height={62} borderRadius="m" />
                </div>

                <div className={styles.selectGroup}>
                    <div className={styles.select}>
                        <Loader width="100%" height={64} borderRadius="s" />
                    </div>
                    <div className={styles.select}>
                        <Loader width="100%" height={64} borderRadius="s" />
                    </div>
                </div>

                <div className={styles.amountInput}>
                    <Loader width="100%" height={62} borderRadius="m" />
                </div>

                <div className={styles.feeWrap}>
                    <div className={styles.fee}>
                        <Loader width={94} height={20} />
                        <Loader width={40} height={20} />
                    </div>
                    <div className={styles.fee}>
                        <Loader width={94} height={20} />
                        <Loader width={40} height={20} />
                    </div>
                </div>

                <Loader width="100%" height={52} borderRadius="m" />
            </>
        )
    }

    return (
        <>
            <div>
                <div className={styles.selectGroup}>
                    <div className={styles.select}>
                        <Loader width="100%" height={66} borderRadius="s" />
                    </div>
                    <div className={styles.select}>
                        <Loader width="100%" height={66} borderRadius="s" />
                    </div>
                </div>
            </div>

            <div className={styles.toggle}>
                <Loader width="100%" height={32} borderRadius="s" />
            </div>

            <Loader width="100%" height={344} borderRadius="s" />
        </>
    )
}

export default SkeletonCrypto
